webpackJsonp([3],{

/***/ "./node_modules/css-loader/lib/css-base.js":
/***/ (function(module, exports) {

	/*
		MIT License http://www.opensource.org/licenses/mit-license.php
		Author Tobias Koppers @sokra
	*/
	// css base code, injected by the css-loader
	module.exports = function() {
		var list = [];
	
		// return the list of modules as css string
		list.toString = function toString() {
			var result = [];
			for(var i = 0; i < this.length; i++) {
				var item = this[i];
				if(item[2]) {
					result.push("@media " + item[2] + "{" + item[1] + "}");
				} else {
					result.push(item[1]);
				}
			}
			return result.join("");
		};
	
		// import a list of modules into the list
		list.i = function(modules, mediaQuery) {
			if(typeof modules === "string")
				modules = [[null, modules, ""]];
			var alreadyImportedModules = {};
			for(var i = 0; i < this.length; i++) {
				var id = this[i][0];
				if(typeof id === "number")
					alreadyImportedModules[id] = true;
			}
			for(i = 0; i < modules.length; i++) {
				var item = modules[i];
				// skip already imported module
				// this implementation is not 100% perfect for weird media query combinations
				//  when a module is imported multiple times with different media queries.
				//  I hope this will never occur (Hey this way we have smaller bundles)
				if(typeof item[0] !== "number" || !alreadyImportedModules[item[0]]) {
					if(mediaQuery && !item[2]) {
						item[2] = mediaQuery;
					} else if(mediaQuery) {
						item[2] = "(" + item[2] + ") and (" + mediaQuery + ")";
					}
					list.push(item);
				}
			}
		};
		return list;
	};


/***/ }),

/***/ "./node_modules/style-loader/addStyles.js":
/***/ (function(module, exports, __webpack_require__) {

	/*
		MIT License http://www.opensource.org/licenses/mit-license.php
		Author Tobias Koppers @sokra
	*/
	var stylesInDom = {},
		memoize = function(fn) {
			var memo;
			return function () {
				if (typeof memo === "undefined") memo = fn.apply(this, arguments);
				return memo;
			};
		},
		isOldIE = memoize(function() {
			return /msie [6-9]\b/.test(self.navigator.userAgent.toLowerCase());
		}),
		getHeadElement = memoize(function () {
			return document.head || document.getElementsByTagName("head")[0];
		}),
		singletonElement = null,
		singletonCounter = 0,
		styleElementsInsertedAtTop = [];
	
	module.exports = function(list, options) {
		if(true) {
			if(typeof document !== "object") throw new Error("The style-loader cannot be used in a non-browser environment");
		}
	
		options = options || {};
		// Force single-tag solution on IE6-9, which has a hard limit on the # of <style>
		// tags it will allow on a page
		if (typeof options.singleton === "undefined") options.singleton = isOldIE();
	
		// By default, add <style> tags to the bottom of <head>.
		if (typeof options.insertAt === "undefined") options.insertAt = "bottom";
	
		var styles = listToStyles(list);
		addStylesToDom(styles, options);
	
		return function update(newList) {
			var mayRemove = [];
			for(var i = 0; i < styles.length; i++) {
				var item = styles[i];
				var domStyle = stylesInDom[item.id];
				domStyle.refs--;
				mayRemove.push(domStyle);
			}
			if(newList) {
				var newStyles = listToStyles(newList);
				addStylesToDom(newStyles, options);
			}
			for(var i = 0; i < mayRemove.length; i++) {
				var domStyle = mayRemove[i];
				if(domStyle.refs === 0) {
					for(var j = 0; j < domStyle.parts.length; j++)
						domStyle.parts[j]();
					delete stylesInDom[domStyle.id];
				}
			}
		};
	}
	
	function addStylesToDom(styles, options) {
		for(var i = 0; i < styles.length; i++) {
			var item = styles[i];
			var domStyle = stylesInDom[item.id];
			if(domStyle) {
				domStyle.refs++;
				for(var j = 0; j < domStyle.parts.length; j++) {
					domStyle.parts[j](item.parts[j]);
				}
				for(; j < item.parts.length; j++) {
					domStyle.parts.push(addStyle(item.parts[j], options));
				}
			} else {
				var parts = [];
				for(var j = 0; j < item.parts.length; j++) {
					parts.push(addStyle(item.parts[j], options));
				}
				stylesInDom[item.id] = {id: item.id, refs: 1, parts: parts};
			}
		}
	}
	
	function listToStyles(list) {
		var styles = [];
		var newStyles = {};
		for(var i = 0; i < list.length; i++) {
			var item = list[i];
			var id = item[0];
			var css = item[1];
			var media = item[2];
			var sourceMap = item[3];
			var part = {css: css, media: media, sourceMap: sourceMap};
			if(!newStyles[id])
				styles.push(newStyles[id] = {id: id, parts: [part]});
			else
				newStyles[id].parts.push(part);
		}
		return styles;
	}
	
	function insertStyleElement(options, styleElement) {
		var head = getHeadElement();
		var lastStyleElementInsertedAtTop = styleElementsInsertedAtTop[styleElementsInsertedAtTop.length - 1];
		if (options.insertAt === "top") {
			if(!lastStyleElementInsertedAtTop) {
				head.insertBefore(styleElement, head.firstChild);
			} else if(lastStyleElementInsertedAtTop.nextSibling) {
				head.insertBefore(styleElement, lastStyleElementInsertedAtTop.nextSibling);
			} else {
				head.appendChild(styleElement);
			}
			styleElementsInsertedAtTop.push(styleElement);
		} else if (options.insertAt === "bottom") {
			head.appendChild(styleElement);
		} else {
			throw new Error("Invalid value for parameter 'insertAt'. Must be 'top' or 'bottom'.");
		}
	}
	
	function removeStyleElement(styleElement) {
		styleElement.parentNode.removeChild(styleElement);
		var idx = styleElementsInsertedAtTop.indexOf(styleElement);
		if(idx >= 0) {
			styleElementsInsertedAtTop.splice(idx, 1);
		}
	}
	
	function createStyleElement(options) {
		var styleElement = document.createElement("style");
		styleElement.type = "text/css";
		insertStyleElement(options, styleElement);
		return styleElement;
	}
	
	function createLinkElement(options) {
		var linkElement = document.createElement("link");
		linkElement.rel = "stylesheet";
		insertStyleElement(options, linkElement);
		return linkElement;
	}
	
	function addStyle(obj, options) {
		var styleElement, update, remove;
	
		if (options.singleton) {
			var styleIndex = singletonCounter++;
			styleElement = singletonElement || (singletonElement = createStyleElement(options));
			update = applyToSingletonTag.bind(null, styleElement, styleIndex, false);
			remove = applyToSingletonTag.bind(null, styleElement, styleIndex, true);
		} else if(obj.sourceMap &&
			typeof URL === "function" &&
			typeof URL.createObjectURL === "function" &&
			typeof URL.revokeObjectURL === "function" &&
			typeof Blob === "function" &&
			typeof btoa === "function") {
			styleElement = createLinkElement(options);
			update = updateLink.bind(null, styleElement);
			remove = function() {
				removeStyleElement(styleElement);
				if(styleElement.href)
					URL.revokeObjectURL(styleElement.href);
			};
		} else {
			styleElement = createStyleElement(options);
			update = applyToTag.bind(null, styleElement);
			remove = function() {
				removeStyleElement(styleElement);
			};
		}
	
		update(obj);
	
		return function updateStyle(newObj) {
			if(newObj) {
				if(newObj.css === obj.css && newObj.media === obj.media && newObj.sourceMap === obj.sourceMap)
					return;
				update(obj = newObj);
			} else {
				remove();
			}
		};
	}
	
	var replaceText = (function () {
		var textStore = [];
	
		return function (index, replacement) {
			textStore[index] = replacement;
			return textStore.filter(Boolean).join('\n');
		};
	})();
	
	function applyToSingletonTag(styleElement, index, remove, obj) {
		var css = remove ? "" : obj.css;
	
		if (styleElement.styleSheet) {
			styleElement.styleSheet.cssText = replaceText(index, css);
		} else {
			var cssNode = document.createTextNode(css);
			var childNodes = styleElement.childNodes;
			if (childNodes[index]) styleElement.removeChild(childNodes[index]);
			if (childNodes.length) {
				styleElement.insertBefore(cssNode, childNodes[index]);
			} else {
				styleElement.appendChild(cssNode);
			}
		}
	}
	
	function applyToTag(styleElement, obj) {
		var css = obj.css;
		var media = obj.media;
	
		if(media) {
			styleElement.setAttribute("media", media)
		}
	
		if(styleElement.styleSheet) {
			styleElement.styleSheet.cssText = css;
		} else {
			while(styleElement.firstChild) {
				styleElement.removeChild(styleElement.firstChild);
			}
			styleElement.appendChild(document.createTextNode(css));
		}
	}
	
	function updateLink(linkElement, obj) {
		var css = obj.css;
		var sourceMap = obj.sourceMap;
	
		if(sourceMap) {
			// http://stackoverflow.com/a/26603875
			css += "\n/*# sourceMappingURL=data:application/json;base64," + btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap)))) + " */";
		}
	
		var blob = new Blob([css], { type: "text/css" });
	
		var oldSrc = linkElement.href;
	
		linkElement.href = URL.createObjectURL(blob);
	
		if(oldSrc)
			URL.revokeObjectURL(oldSrc);
	}


/***/ }),

/***/ "./src/components/PostListing/index.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = PostListing;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__("./node_modules/gatsby-link/index.js");
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _ResponsiveImage = __webpack_require__("./src/components/ResponsiveImage/index.js");
	
	var _ResponsiveImage2 = _interopRequireDefault(_ResponsiveImage);
	
	var _styleModule = __webpack_require__("./src/components/PostListing/style.module.css");
	
	var _styleModule2 = _interopRequireDefault(_styleModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var getPostImage = function getPostImage(post, images) {
	  var imagePathRegex = post.fileAbsolutePath.replace('index.md', 'hero');
	  var filteredImages = images.filter(function (image) {
	    return image.node.id.match(imagePathRegex);
	  });
	  if (filteredImages.length > 0) {
	    return filteredImages[0].node.responsiveSizes;
	  }
	  return false;
	};
	
	function PostListing(props) {
	  var post = props.post,
	      images = props.images;
	
	  var responsiveImageData = getPostImage(post, images);
	  return _react2.default.createElement(
	    'div',
	    { className: _styleModule2.default.grid },
	    _react2.default.createElement(
	      _gatsbyLink2.default,
	      { to: post.frontmatter.path },
	      _react2.default.createElement(
	        'div',
	        { className: _styleModule2.default.image },
	        responsiveImageData && _react2.default.createElement(_ResponsiveImage2.default, { imgData: responsiveImageData })
	      )
	    ),
	    _react2.default.createElement(
	      _gatsbyLink2.default,
	      { to: post.frontmatter.path },
	      _react2.default.createElement(
	        'h2',
	        { className: _styleModule2.default.title },
	        post.frontmatter.title
	      ),
	      _react2.default.createElement(
	        'p',
	        { className: _styleModule2.default.date },
	        _react2.default.createElement(
	          'i',
	          null,
	          post.frontmatter.date
	        )
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        post.frontmatter.summary
	      )
	    )
	  );
	}
	
	PostListing.propTypes = {
	  post: _propTypes2.default.object.isRequired,
	  images: _propTypes2.default.arrayOf(_propTypes2.default.object).isRequired
	};
	module.exports = exports['default'];

/***/ }),

/***/ "./node_modules/css-loader/index.js?modules&minimize&importLoaders=1!./node_modules/postcss-loader/index.js!./src/components/PostListing/style.module.css":
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__("./node_modules/css-loader/lib/css-base.js")();
	// imports
	
	
	// module
	exports.push([module.id, "._2bM1zjd4Q67y3miWlRKrxm a,._2bM1zjd4Q67y3miWlRKrxm a:hover{color:#000;text-decoration:none}.lpb_UKvuTWe5RrqG2RG4b{display:none}._22uGctTlYDt71D6I_J4Y9T{margin-top:0;margin-bottom:0}._3fSrp53yGfVIZgALeHJcbo{margin-bottom:.75em}@media (min-width:600px){._2bM1zjd4Q67y3miWlRKrxm{grid-template-columns:2fr 3fr;display:grid;grid-column-gap:20px}.lpb_UKvuTWe5RrqG2RG4b{display:inline}}@media (min-width:1050px){._22uGctTlYDt71D6I_J4Y9T{margin-top:.2em}}", ""]);
	
	// exports
	exports.locals = {
		"grid": "_2bM1zjd4Q67y3miWlRKrxm",
		"image": "lpb_UKvuTWe5RrqG2RG4b",
		"title": "_22uGctTlYDt71D6I_J4Y9T",
		"date": "_3fSrp53yGfVIZgALeHJcbo"
	};

/***/ }),

/***/ "./src/components/PostListing/style.module.css":
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__("./node_modules/css-loader/index.js?modules&minimize&importLoaders=1!./node_modules/postcss-loader/index.js!./src/components/PostListing/style.module.css");
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__("./node_modules/style-loader/addStyles.js")(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js?modules&minimize&importLoaders=1!../../../node_modules/postcss-loader/index.js!./style.module.css", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js?modules&minimize&importLoaders=1!../../../node_modules/postcss-loader/index.js!./style.module.css");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),

/***/ "./src/components/ResponsiveImage/index.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _styles = __webpack_require__("./src/components/ResponsiveImage/styles.js");
	
	var _styles2 = _interopRequireDefault(_styles);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/*
	  Import styles as js object rather than e.g. css-modules
	  so we can combine them dynamically
	*/
	
	
	var ResponsiveImage = function (_React$Component) {
	  _inherits(ResponsiveImage, _React$Component);
	
	  function ResponsiveImage(props) {
	    _classCallCheck(this, ResponsiveImage);
	
	    var _this = _possibleConstructorReturn(this, (ResponsiveImage.__proto__ || Object.getPrototypeOf(ResponsiveImage)).call(this, props));
	
	    _this.state = {
	      imageLoading: true
	    };
	
	    _this.imageLoaded = _this.imageLoaded.bind(_this);
	    return _this;
	  }
	
	  _createClass(ResponsiveImage, [{
	    key: 'imageLoaded',
	    value: function imageLoaded() {
	      this.setState({
	        imageLoading: false
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      // Destructure props
	      var _props$imgData = this.props.imgData,
	          aspectRatio = _props$imgData.aspectRatio,
	          base64 = _props$imgData.base64,
	          src = _props$imgData.src,
	          srcSet = _props$imgData.srcSet,
	          sizes = _props$imgData.sizes;
	      // Calculate style values
	
	      var maxWidth = sizes.split(',')[1].replace(' ', '');
	      var padding = 1 / aspectRatio * 100 + '%';
	      var imageLoadStyles = this.state.imageLoading ? _styles2.default.imageLoading : _styles2.default.imageLoaded;
	
	      return (
	        // Use spread operator (...) to merge objects
	        _react2.default.createElement(
	          'figure',
	          { style: _extends({}, _styles2.default.wrapper, { maxWidth: maxWidth }) },
	          _react2.default.createElement(
	            'div',
	            {
	              style: _extends({}, _styles2.default.backgroundImage, {
	                paddingBottom: padding,
	                backgroundImage: 'url(\'' + base64 + '\')'
	              })
	            },
	            _react2.default.createElement('img', {
	              style: _extends({}, _styles2.default.image, imageLoadStyles),
	              alt: 'altTag',
	              title: 'title',
	              src: src,
	              srcSet: srcSet,
	              sizes: sizes,
	              onLoad: this.imageLoaded
	            })
	          )
	        )
	      );
	    }
	  }]);
	
	  return ResponsiveImage;
	}(_react2.default.Component);
	
	exports.default = ResponsiveImage;
	
	
	ResponsiveImage.propTypes = {
	  imgData: _propTypes2.default.shape({
	    aspectRatio: _propTypes2.default.number.isRequired,
	    base64: _propTypes2.default.string.isRequired,
	    src: _propTypes2.default.string.isRequired,
	    srcSet: _propTypes2.default.string.isRequired,
	    sizes: _propTypes2.default.string.isRequired
	  }).isRequired
	};
	module.exports = exports['default'];

/***/ }),

/***/ "./src/components/ResponsiveImage/styles.js":
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  wrapper: {
	    margin: '0 auto',
	    display: 'block'
	  },
	  backgroundImage: {
	    backgroundSize: 'cover',
	    backgroundRepeat: 'no-repeat',
	    width: '100%',
	    display: 'inline-block',
	    overflow: 'hidden !important',
	    height: 0,
	    position: 'relative'
	  },
	  image: {
	    position: 'absolute'
	  },
	  imageLoading: {
	    opacity: 0
	  },
	  imageLoaded: {
	    opacity: 1,
	    transition: 'opacity 500ms',
	    transform: 'translate3d(0, 0, 0)'
	  }
	};
	module.exports = exports['default'];

/***/ }),

/***/ "./node_modules/babel-loader/lib/index.js?{\"plugins\":[\"/Users/matt/Documents/code/gatsby-blog-starter-kit/node_modules/gatsby/dist/utils/babel-plugin-extract-graphql.js\",\"/Users/matt/Documents/code/gatsby-blog-starter-kit/node_modules/babel-plugin-add-module-exports/lib/index.js\",\"/Users/matt/Documents/code/gatsby-blog-starter-kit/node_modules/babel-plugin-add-module-exports/lib/index.js\",\"/Users/matt/Documents/code/gatsby-blog-starter-kit/node_modules/babel-plugin-transform-object-assign/lib/index.js\"],\"presets\":[\"/Users/matt/Documents/code/gatsby-blog-starter-kit/node_modules/babel-preset-env/lib/index.js\",\"/Users/matt/Documents/code/gatsby-blog-starter-kit/node_modules/babel-preset-stage-0/lib/index.js\",\"/Users/matt/Documents/code/gatsby-blog-starter-kit/node_modules/babel-preset-react/lib/index.js\"],\"cacheDirectory\":true}!./src/pages/index.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.pageQuery = undefined;
	exports.default = Index;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _PostListing = __webpack_require__("./src/components/PostListing/index.js");
	
	var _PostListing2 = _interopRequireDefault(_PostListing);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var removeDraftPosts = function removeDraftPosts(post) {
	  var frontmatter = post.node.frontmatter;
	  return frontmatter.draft !== 'true' && frontmatter.title.length > 0;
	};
	
	function Index(_ref) {
	  var data = _ref.data;
	
	  var posts = data.allMarkdownRemark.edges;
	  var images = data.allImageSharp.edges;
	
	  return _react2.default.createElement(
	    'div',
	    null,
	    posts.filter(removeDraftPosts).map(function (_ref2) {
	      var post = _ref2.node;
	      return _react2.default.createElement(_PostListing2.default, { key: post.id, post: post, images: images });
	    })
	  );
	}
	
	var pageQuery = exports.pageQuery = '** extracted graphql fragment **';

/***/ })

});


// WEBPACK FOOTER //
// page-component---src-pages-index-js-1830ad7cf33dad86b779.js